import axios from 'axios';
import { createQuery } from 'react-query-kit';

import { restUrl } from '@/services/utils';

import { ExportTemplate } from './exportItems';

export const useTemplateMappings = createQuery({
    queryKey: ['templateMappings'],
    fetcher: async () => {
        const response = await axios.get(restUrl('export/mappings?templateMappings=true'));
        const body = response.data;
        if (Array.isArray(body)) {
            return body as ExportTemplate[];
        }
        if (Array.isArray(body?.data)) {
            return body.data as ExportTemplate[];
        }
        return [];
    },
});
